<img alt="image" *ngIf="imageSource" [src]="image" />